import { Component, input } from '@angular/core';

import { BaseMediaApiModel } from '@era/inroom-sdk';

@Component({
  selector: 'era-radio-channel',
  templateUrl: './radio-channel.component.html',
  styleUrls: ['./radio-channel.component.scss'],
})
export class RadioChannelComponent {
  readonly radioChannel = input.required<BaseMediaApiModel>();
}
